module.exports = __webpack_public_path__ + "img/cattunnel34.bb6e15bd.jpg";